import request from './request.js';
import {requestbody} from './request.js'

export async function init(params = {

}) {
    return await requestbody('/cyry/init', 'post', params)
}
export async function query(params = {

}) {
    return await requestbody('/cyry/query', 'post', params)
}
export async function getFirstNum(params = {

}) {
    return await requestbody('/cyry/detail/getFirstNum', 'post', params)
}
export async function detailadd(params = {

}) {
    return await requestbody('/cyry/detail/add', 'post', params)
}
export async function queryNsrinfo(params = {

}) {
    return await requestbody('/sys/queryNsrinfo', 'post', params)
}
export async function summaryquery(params = {

}) {
    return await requestbody('/cyry/summary/query', 'post', params)
}
